import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '../../services/header.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mono-common-modal-header',
  templateUrl: './modal-header.component.html'
})

export class ModalHeaderComponent implements OnInit {

  @Input() progressBar?: boolean = false;
  @Input() headerText: string;
  @Input() hideTheHeader?: boolean;
  @Input() signInHeader?: boolean;

  @Output() closeButtonClick = new EventEmitter();

  @ViewChild('closeButton') closeButton: ElementRef;

  public previousUrl: string;

  constructor(private router: Router, private headerService: HeaderService) { }

  ngOnInit(): void {
    this.headerService.getLocation().pipe(take(1)).subscribe(location => {
      this.previousUrl = location;
    })
  }

  public closeButtonClicked() {
    if(this.closeButtonClick.observers.length) {
      this.closeButtonClick.emit();
    } else {
      this.router.navigateByUrl(this.previousUrl);
    }
  }
}
